import * as React from 'react';
import * as ReactDOM from 'react-dom';
import App from './App';
import './App.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

ReactDOM.render(
  <App />,
  document.getElementById('root') as HTMLElement
);
serviceWorkerRegistration.register();
